import React from 'react'
import { Menu } from '@headlessui/react';
import { useState } from 'react';
import { WorkshopService } from '../../services/workshop'
import { useEffect } from 'react';
import NotFound from '../NotFound/NotFound';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useParams, useHistory } from 'react-router-dom';


import DeleteWorkShop from './DeleteWorkShop';
import CancelWorkShop from './CancelWorkShop';
import { Link } from 'react-router-dom';

const tabColor = {
    "ACTIVE": "#82C43C",
    "IN-ACTIVE": " #979797",
    "CANCELLED": "#FC5A5A",
    "REG. CLOSED": "#FF974A",
    "COMPLETED": "#4397F7",
};

const Workshops = () => {

    let params = useParams();
    const history = useHistory();
    let workshopsPerPage = 10;
    let [startIdx, setStartIdx] = useState(0);
    const [workshops, setWorkshops] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [pageCount, setPageCount] = useState(999999999);
    const [statuses, setStatuses] = useState([]);
    let [isOpen, setIsOpen] = useState(false)
    let [isOpenCancel, setIsOpenCancel] = useState(false)
    let [selectedWorkshop, setSelectedWorkshop] = useState({})
    let [selectedStatus, setSelectedStatus] = useState("");
    let [workshopMain, setWorkshopMain] = useState([]);

    // function isWorkshopCancelled(end_date){
    //     var dateToday=new Date();
    //     var hideDate = new Date(end_date);
    //     hideDate.setDate(hideDate.getDate() + parseInt(1));
    //     console.log(hideDate.toISOString());
    //     return dateToday.toISOString() > hideDate.toISOString()
    // }

    function closeModal() {
        setIsOpen(false)
    }

    function openModal() {
        setIsOpen(true)
    }

    function closeCancelModal() {
        setIsOpenCancel(false)
    }

    function openCancelModal() {
        setIsOpenCancel(true)
    }

    const getAllWorkshop = async () => {
        await WorkshopService.getAllWorkshop(pageCount, pageNumber).then(data => {
            setWorkshopMain(data.workshop.workshops);
            // setWorkshops(data.workshop.workshops.slice(pageNumber * workshopsPerPage, ((pageNumber + 1) * workshopsPerPage)));
            setWorkshopMain(data.workshop.workshops);

            let totalWorkshops = data.workshop.count;
            if (totalWorkshops % workshopsPerPage === 0) {
                setTotalPages(parseInt(totalWorkshops / workshopsPerPage));
            }
            else {
                setTotalPages(parseInt(totalWorkshops / workshopsPerPage) + 1);
            }
        })

    }


    const getAllWorkshopStatuses = async () => {
        await WorkshopService.getAllWorkshopStatuses().then((res) => {
            setStatuses(res.data.data);
        })
    }

    const formatDate = (date) => {
        return ((moment(date)).format('DD MMM YY'))
    }

    const formatDateStart = (date) => {
        return ((moment(date)).format('DD MMM'))
    }

    const formatTime = (date) => {
        return ((moment(date)).format('hh:mm a'))
    }

    const changeStatus = async (uuid, state) => {
        const toastId = toast.loading('Updating Workshop Status');

        await WorkshopService.changeWorkshopState(uuid, { state }).then(res => {
            if (res.status === 200) {
                console.log(res.data.data);
                toast.success(res.data.message, {
                    id: toastId
                });
                toast.dismiss(toastId);
                getAllWorkshop();
            }
        }).catch(e => {
            console.log(e);
            toast.error(e.response.data, {
                id: toastId
            })
            toast.dismiss(toastId);
        })

    }

    useEffect(() => {
        getAllWorkshop();
        getAllWorkshopStatuses();
    }, [isOpen])

    useEffect(() => {
        // setWorkshops(workshopMain.slice((pageNumber - 1) * workshopsPerPage, ((pageNumber) * workshopsPerPage)));
        setWorkshops(workshopMain);
        setStartIdx((pageNumber - 1) * (workshopsPerPage));
    }, [pageNumber, workshopMain])

    return (
        <>
            {isOpen && <DeleteWorkShop
                uuid={selectedWorkshop.uuid}
                openModal={openModal}
                closeModal={closeModal}
                isOpen={isOpen}
            />}
            {isOpenCancel && <CancelWorkShop
                state={selectedStatus}
                uuid={selectedWorkshop.uuid}
                openModal={openCancelModal}
                closeModal={closeCancelModal}
                isOpen={isOpenCancel}
                changeStatus={changeStatus}
            />}
            <div className="users w-100 h-full flex flex-col">
                <div className="settings-title">
                    <div className="row d-flex d-flex flex-md-fill flex-wrap">
                        <div className="col-md-7 col-6 d-flex flex-md-fill flex-column">
                            <h1 className="fz24 black fw-po-medium mb-0">All Workshop ({workshops?.length})</h1>
                            {/* <p className="fz16 black-dark-700 mb-0 d-md-block d-none">Manage all users for {companyDetails.name}</p> */}
                        </div>
                        <div className="col-md-5 col-6 d-flex justify-content-end align-items-md-end aling-items-center d-flex flex-md-fill">
                            <div>
                                {/* <div className={`border rounded px-2 py-1 flex mr-3 items-center ${searchText ? 'border-primary' : ''} `}>
                                    <SearchIcon className='mr-2' />
                                    <input
                                        type="text"
                                        placeholder='Search For Users'
                                        className=' w-100 focus:outline-none text-sm'
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                    {searchText &&
                                        <div className="cursor-pointer" onClick={() => setSearchText('')}>
                                            <SearchCloseIcon />
                                        </div>}
                                </div> */}
                                <div className='ml-6'>
                                    <Link to="workshops/new-workshop">
                                        <button className='flex items-center text-14 font-medium text-white !bg-primary px-2 py-1 rounded hover:opacity-90'>
                                            <svg className="mr4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <mask id="path-1-inside-1_1117_451" fill="white">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z"></path>
                                                </mask>
                                                <path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" fill="white"></path><path d="M12.6665 11.3335H9.66653V14.3335H12.6665V11.3335ZM12.6665 12.6668V9.66678H9.66653V12.6668H12.6665ZM11.3332 12.6668H14.3332V9.66678H11.3332V12.6668ZM11.3332 11.3335V14.3335H14.3332V11.3335H11.3332ZM12.6665 14.3335H17.3331V8.33347H12.6665V14.3335ZM17.3331 14.3335C16.0444 14.3335 14.9998 13.2888 14.9998 12.0001H20.9998C20.9998 9.97509 19.3581 8.33347 17.3331 8.33347V14.3335ZM14.9998 12.0001C14.9998 10.7115 16.0444 9.66678 17.3331 9.66678V15.6668C19.3581 15.6668 20.9998 14.0252 20.9998 12.0001H14.9998ZM17.3331 9.66678H12.6665V15.6668H17.3331V9.66678ZM9.66653 12.6668V17.3333H15.6665V12.6668H9.66653ZM9.66653 17.3333C9.66653 16.0447 10.7112 15 11.9999 15V21C14.0249 21 15.6665 19.3584 15.6665 17.3333H9.66653ZM11.9999 15C13.2885 15 14.3332 16.0447 14.3332 17.3333H8.33322C8.33322 19.3584 9.97484 21 11.9999 21V15ZM14.3332 17.3333V12.6668H8.33322V17.3333H14.3332ZM11.3332 9.66678H6.66665V15.6668H11.3332V9.66678ZM6.66665 9.66678C7.95533 9.66678 9 10.7115 9 12.0001H3C3 14.0252 4.64162 15.6668 6.66665 15.6668V9.66678ZM9 12.0001C9 13.2888 7.95533 14.3335 6.66665 14.3335V8.33347C4.64162 8.33347 3 9.97509 3 12.0001H9ZM6.66665 14.3335H11.3332V8.33347H6.66665V14.3335ZM14.3332 11.3335V6.6669H8.33322V11.3335H14.3332ZM14.3332 6.6669C14.3332 7.95557 13.2885 9.00024 11.9999 9.00024V3.00024C9.97484 3.00024 8.33322 4.64186 8.33322 6.6669H14.3332ZM11.9999 9.00024C10.7112 9.00024 9.66653 7.95557 9.66653 6.6669H15.6665C15.6665 4.64186 14.0249 3.00024 11.9999 3.00024V9.00024ZM9.66653 6.6669V11.3335H15.6665V6.6669H9.66653Z" fill="white" mask="url(#path-1-inside-1_1117_451)"></path>
                                            </svg> Create New
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="urer-table ml-24 mt-24">
                    <div className="def-table pr-24 !h-full">
                        {workshops.length > 0 ?
                            <table className="table">
                                <thead className='text-left bg-black100 rounded-lg '>
                                    <tr className='px-4 py-2'>
                                        <th className='w-10'>S.No</th>
                                        <th>Workshop Name</th>
                                        <th>Date</th>
                                        <th>Time</th>
                                        <th>Category</th>
                                        <th>Mentor</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {
                                        workshops && workshops?.map((workshop, index) =>
                                            <tr key={workshop.id}>
                                                <td className='pl-6'>{startIdx + index + 1}</td>
                                                <td
                                                    onClick={() => history.push("workshops/enrolled-users/" + workshop.uuid)}
                                                    style={{ cursor: "pointer" }}
                                                    className=''
                                                >
                                                    <span className='text-capitalize three-dots' title={(workshop.name)}>{workshop.name}</span>
                                                </td>
                                                <td>{formatDateStart(workshop.start_date) + " - " + formatDate(workshop.end_date)}</td>
                                                <td>{formatTime(workshop.start_time) + " - " + formatTime(workshop.end_time)}</td>
                                                <td>{workshop.category}</td>
                                                <td><span className='mentor-name' title={(workshop.mentors)}>{workshop.mentors && workshop.mentors.length > 0 && workshop.mentors[0] != null ? workshop.mentors.map((mentor, index) => {
                                                    return (
                                                        <React.Fragment key={`${index}-${mentor}`}>
                                                            {mentor + " "}
                                                        </React.Fragment>
                                                    )
                                                }) : "-"}
                                                </span>
                                                </td>
                                                <td>
                                                    <Menu as="div" className="relative">
                                                        <Menu.Button
                                                            className="flex py-1 px-2.5 justify-center text-white py-1.4 text-14 font-medium items-center rounded tracking-wide w-[150px]"
                                                            style={{ background: tabColor[workshop.status] }}
                                                        >

                                                            {workshop.status} <svg xmlns="http://www.w3.org/2000/svg" className="ml-auto" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M12 13.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L12 13.5858Z" fill="white" />
                                                            </svg>
                                                        </Menu.Button>
                                                        <Menu.Items className="absolute right-2 mt-2 p-3 w-48 origin-top-left divide-y divide-gray-100 rounded bg-white drop-shadow-default focus:outline-none z-[100] w-[150px]">
                                                            <div className="">
                                                                {statuses.filter(statusFilter => statusFilter != "DRAFT" && statusFilter != "DELETED").map(
                                                                    (status, index) =>
                                                                        <Menu.Item key={`${index}_${status}`}>

                                                                            <button
                                                                                className='group flex w-full items-center rounded px-2 py-1 text-14 hover:bg-black200'
                                                                                onClick={() => {
                                                                                    if (status === "CANCELLED") {
                                                                                        setSelectedWorkshop(workshop);
                                                                                        setSelectedStatus(status);
                                                                                        openCancelModal();

                                                                                    } else
                                                                                        changeStatus(workshop.uuid, status);
                                                                                }}
                                                                            >
                                                                                {status}
                                                                            </button>

                                                                        </Menu.Item>
                                                                )
                                                                }
                                                            </div>
                                                        </Menu.Items>
                                                    </Menu>
                                                </td>
                                                <td className="dropdown view-more" onClick={() => { }}>

                                                    <button
                                                        className="bg-tr border-0 "
                                                        type="button"
                                                        id="dropdownMenuButton"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17Z"
                                                                fill="#B5B5BE"
                                                            />
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                                                                fill="#B5B5BE"
                                                            />
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3Z"
                                                                fill="#B5B5BE"
                                                            />
                                                        </svg>
                                                    </button>
                                                    <div
                                                        className="dropdown-menu dropdown-menu-right"
                                                        aria-labelledby="dropdownMenuButton"
                                                    >
                                                        <Link className="dropdown-item" to={`workshops/edit-workshop/${workshop.uuid}`}
                                                        >
                                                            Edit Workshop
                                                        </Link>

                                                        <a className="dropdown-item" onClick={() => {
                                                            navigator.clipboard.writeText(workshop.zoom_link)
                                                            toast.success("Zoom Link Copied to Clipboard!")
                                                        }}
                                                        >
                                                            Copy Zoom Link
                                                        </a>

                                                        <Link className="dropdown-item" to={"/settings/learning-centre/workshops/enrolled-users/" + workshop.uuid}>
                                                            View Enrolled Users
                                                        </Link>
                                                        <a className="dropdown-item" onClick={() => {
                                                            navigator.clipboard.writeText(`https://plus.propacity.in/landing-page/${workshop.uuid}`).then(function () {
                                                                toast.success('Link Copied');
                                                            }, function (err) {
                                                                toast.error('Could not copy Link');
                                                            });
                                                        }}
                                                        >
                                                            Copy Payment Plan
                                                        </a>
                                                        <a className="dropdown-item" onClick={() => {
                                                            setSelectedWorkshop(workshop);
                                                            setSelectedStatus("CANCELLED");
                                                            openCancelModal();
                                                        }}
                                                        >
                                                            Cancel Workshop
                                                        </a>

                                                        <a className="dropdown-item" onClick={() => { changeStatus(workshop.uuid, "CLOSED"); }}
                                                        >
                                                            Close Registeration
                                                        </a>

                                                        <a className="dropdown-item" onClick={() => {
                                                            setSelectedWorkshop(workshop);
                                                            openModal();
                                                        }}
                                                        >
                                                            Delete Workshop
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }

                                </tbody>
                            </table>
                            : <NotFound message="No workshop found" />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default Workshops
